import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { CommonService } from '../../services/commonservice';
import { CommonModule } from '@angular/common';
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid/isg-grid.component';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { ColDef } from 'ag-grid-community';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'questionmatrix',
  standalone: true,
  imports: [FormsModule, CommonModule, ReactiveFormsModule, IsgGridComponent],
  templateUrl: './page-questionmatrix.component.html',
  styleUrl: './page-questionmatrix.component.scss',
  providers: [CommonService],
})

export class PageQuestionMatrixComponent extends BaseHttpReqRespService implements OnInit {
  @ViewChild('CreateCategoryModal') categoryModal!: TemplateRef<any>;
  @ViewChild('deleteRowItemModal') deleteRowItemModalRef!: TemplateRef<any>;
  @ViewChild('deleteColumnHeaderModal') deleteColumnHeaderModalRef!: TemplateRef<any>;
  @ViewChild('deleteColumnItemModal') deleteColumnItemModalRef!: TemplateRef<any>;
  @ViewChild('deleteDefaultValueModal') deleteDefaultValueModalRef!: TemplateRef<any>;
  @ViewChild('rangeColumnItemModal') rangeColumnItemModalRef!: TemplateRef<any>;

  columnHeaderGridConfig: Partial<IsgGridConfig> = {
    height: '200px',
    pagination: false,
    rowDragManaged: true,
  };

  columnItemGridConfig: Partial<IsgGridConfig> = {
    height: '240px',
    pagination: false,
    rowDragManaged: true,
  };

  rowItemGridConfig: Partial<IsgGridConfig> = {
    height: '280px',
    pagination: false,
    rowDragManaged: true,
  };

  defaultValueGridConfig: Partial<IsgGridConfig> = {
    height: '210px',
    pagination: false,
    rowDragManaged: true,
  };
  questionForm!: FormGroup;
  columnHeaderForm!: FormGroup;
  columnItemForm!: FormGroup;
  rowItemForm!: FormGroup;
  questionDefaultValueForm!: FormGroup;
  rangeColumnItemForm!: FormGroup;
  public showAddColumnModal = false;
  public successOrFailureMessage: string = '';
  MATRIX_ENDPOINT = API_ENDPOINTS.QUESTION_MATRIX;
 SURVEY_ENDPOINT = API_ENDPOINTS.SURVEY;
  public columnDataNew!: ColumnItem[];
  public columnHeaderList!: ColumnHeader[];
  public rowItemList!: RowItem[];
  public dataTypeList!: DataType[];
  public controlTypeList!: ControlType[];
  public picklistReferenceList!: PickListreference[];
  public questionColumnHeaderList!: ColumnHeader[];
  public questionDefaultValueList!: QuestionDefaultValue[];
  public selectedColumnHeaderList: string[] = [];
  public columnHeaderRows: Array<{ questionColumnHeaderId: string, description: string }> = [];
  private gridApiColumnHeader!: any;
  private gridApiColumnItem!: any;
  private gridApiRowItem!: any;
  private gridApiDefaultValue!: any;
  public questionId!: number;
  public questionColumnHeaderId!: number;
  public rowItemHeaderId!: number;
  public questionColumnItemId: number = 0;
  public questionDefaultValueId!: number;
  public folderId!: number;
  public folderName!: string;
  public rowItemDeleteId!: number;
  public orderColumnHeaders: string[] = [];
  public orderColumnItems: string[] = [];
  public orderRowItems: string[] = [];
  public redirectedSectionId!: number;
  public redirectedSurveyId!: number;

  myAppUrl: any;

  quesCategoryForm!: FormGroup;
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  public questionCategoryList: questionCategory[] = [];
  public questionCategoryId: number = 0;
  public width!: number;

  // Add this property to the class
  public hideColumnItemForm: boolean = false;
  public hiderangeColumnItemForm: boolean = false;

  constructor(private _router: Router, public http: HttpClient,
    @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder,
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    private modalService: NgbModal,
    private commonService: CommonService, private route: ActivatedRoute,
    private renderer: Renderer2, private EncrDecr: EncrDecrService
    , @Inject('CONFIG_SETTINGS') configSettings: any) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.myAppUrl = this.baseUrl;
    this.http = http
  }

  ngOnInit() {

    this.questionId = + this.route.snapshot.queryParams["questionId"];
    this.folderId = + this.route.snapshot.queryParams["folderId"];
    this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
    this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
    if (this.folderId == -1)
      this.folderName = '';
    else
      this.folderName = this.route.snapshot.queryParams["folderName"];
    this.buildAllForms();
    this.AddColumnData(false);
    this.AddRangeColumnData();
    this.getMatrixQuestionData(this.questionId);

    this.quesCategoryForm = this.formBuilder.group({
      'quesCategoryName': new FormControl(null, Validators.required)
    });

    this.getQuestionCategoryList();
  }

  getQuestionCategoryList() {
    this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.QUESTION_CATEGORY_LIST).subscribe(result => {
      this.questionCategoryList = result;
    }, error => console.error(error));

  }

  AddQuesCategory() {
    let tmpQuesCategoryName = this.quesCategoryForm.get('quesCategoryName')?.value;
    let resourceIdList = "quesCategoryName=" + tmpQuesCategoryName;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(resourceIdList, this.myAppUrl + '/' + this.QUESTION_ENDPOINT.SAVE_CATEGORY, httpOptions).subscribe(result => {
      this.getQuestionCategoryList();


    }, error => console.error(error));
  }

  ResetQuesCategoryForm() {
    this.quesCategoryForm.reset();
  }

  buildAllForms() {
    this.questionForm = this.formBuilder.group({
      qsDescription: ['', [Validators.required, this.noWhitespaceValidator]],
      questionId: [0],
      createdBy: [0],
      modifiedBy: [0],
      folderId: [this.folderId],
      isHideRowHeader: [0],
      isEveryRowMandatory: [0],
      questionCategoryId: [''],
      width: [''],
      shortName: ['']
    });

    this.columnHeaderForm = this.formBuilder.group({
      qsHeaderDescription: ['', [Validators.required, this.noWhitespaceValidator]],
      questionId: [this.questionId],
      questionColumnHeaderId: [0],
    })

    this.columnItemForm = this.formBuilder.group({
      columnItemDescription: ['', [Validators.required, this.noWhitespaceValidator]],
      questionColumnHeaderId: [0],
      controlTypeId: [0],
      picklistReferenceId: [0],
      minValue: [''],
      maxValue: [''],
      dataTypeId: [0],
      isMandatory: [0],
      isEnabled: [1],
      questionId: [this.questionId],
      questionColumnItemId: [0],
      displayOrder: [1],
      width: [0],
    })

    this.rowItemForm = this.formBuilder.group({
      rowItemHeaderDescription: ['', [Validators.required, this.noWhitespaceValidator]],
      questionId: [this.questionId],
      rowItemHeaderId: [this.rowItemHeaderId],

    })
    this.questionDefaultValueForm = this.formBuilder.group({
      defaultValue: ['', [Validators.required, this.noWhitespaceValidator]],
      questionId: [this.questionId],
      questionDefaultValueId: [0],
      questionRowItemId: [null, [Validators.required]],
      questionColumnItemId: [null, [Validators.required]]
    })
    this.rangeColumnItemForm = this.formBuilder.group({
      startRange: ['', [
        Validators.required,
        this.noWhitespaceValidator,
        Validators.pattern(/^-?\d+(\.\d+)?$/) // Ensures numeric input
      ]],
      endRange: ['', [
        Validators.required,
        this.noWhitespaceValidator,
        Validators.pattern(/^-?\d+(\.\d+)?$/) // Ensures numeric input
      ]],
      questionId: [this.questionId]
    })
  }

  onControlTypeChange() {
    let parameter = "?controlTypeId=" + this.columnItemForm.controls.controlTypeId.value;

    this.commonService.httpGet("", this.myAppUrl + '/' + this.MATRIX_ENDPOINT.PICK_LIST_REFERENCE_MEMBERS + parameter).subscribe(response => {
      this.picklistReferenceList = response;
    }, error => {
      console.log(error);
    });
  }

  getMatrixQuestionData(questionId: number) {
    let parameter = "?questionId=" + questionId;
    this.commonService.httpGet("", this.myAppUrl + '/' + this.MATRIX_ENDPOINT.MATRIX_QUESTION_DATA + parameter).subscribe(
      response => {
        this.columnHeaderList = response.listOfColumnHeader;
        this.columnDataNew = response.listOfColumnItem;
        this.rowItemList = response.listOfRowItem;
        this.questionForm.patchValue({
          'questionId': response.questionId,
          'qsDescription': response.qsDescription,
          'isHideRowHeader': response.isHideRowHeader,
          'isEveryRowMandatory': response.isEveryRowMandatory,
          'questionCategoryId': response.questionCategoryId,
          'width': response.width,
          'shortName': response.shortName
        });
        this.questionDefaultValueList = response.listOfDefaultValue;
      }, error => {
        console.log(error);
      }
    );
  }

  onGridReady(params: any) {
    this.gridApiColumnHeader = params.api;
    params.api.sizeColumnsToFit();
  }

  onColumnGridReady(params: any) {
    this.gridApiColumnItem = params.api;
    params.api.sizeColumnsToFit();
  }
  onRowGridReady(params: any) {
    this.gridApiRowItem = params.api;
    params.api.sizeColumnsToFit();
  }

  onDefaultValueGridReady(params: any) {
    this.gridApiDefaultValue = params.api;
    params.api.sizeColumnsToFit();
  }

  arrangeOrderColumnHeader() {
    var columnHeaderIdList = '';
    this.gridApiColumnHeader.forEachNode(function (rowNode: any) {
      columnHeaderIdList = columnHeaderIdList + rowNode.data.questionColumnHeaderId + ',';
    });
    let param = "?questionId=" + this.questionId + "&columnHeaderIdList=" + columnHeaderIdList;
    this.commonService.httpGet("", this.myAppUrl + '/' + this.MATRIX_ENDPOINT.ARRANGE_COLUMN_HEADER + param).subscribe(result => {
      this.columnHeaderList = result;
      this.orderColumnHeaders = [];
    }, error => console.error(error));
    this.columnHeaderForm.reset();
  }

  arrangeOrderColumnItem() {
    var columnItemIdList = '';
    this.gridApiColumnItem.forEachNode(function (rowNode: any) {
      columnItemIdList = columnItemIdList + rowNode.data.questionColumnItemId + ',';

    });
    let param = "?questionId=" + this.questionId + "&columnItemIdList=" + columnItemIdList;

    this.commonService.httpGet("", this.myAppUrl + '/' + this.MATRIX_ENDPOINT.ARRANGE_COLUMN_ITEM + param).subscribe(result => {
      this.columnDataNew = result;
      //this.orderColumnHeaders = [];
    }, error => console.error(error));
    this.columnItemForm.reset();
  }
  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  arrangeOrderRowItem() {

    var rowItemIdList = '';
    this.gridApiRowItem.forEachNode(function (rowNode: any) {

      rowItemIdList = rowItemIdList + rowNode.data.rowItemHeaderId + ',';

    });
    let orderRowItems = "?questionId=" + this.questionId + "&rowItemIdList=" + rowItemIdList;
    this.commonService.httpGet('', this.myAppUrl + '/' + this.MATRIX_ENDPOINT.ARRANGE_ROW_ITEM + orderRowItems).subscribe(result => {
      this.rowItemList = result;
      this.orderRowItems = [];
    }, error => console.error(error));
    this.rowItemForm.reset();
  }
  AddRangeColumnData() {
    this.rangeColumnItemForm = this.formBuilder.group({
      startRange: ['', [
        Validators.required,
        this.noWhitespaceValidator,
        Validators.pattern(/^-?\d+(\.\d+)?$/) // Ensures numeric input
      ]],
      endRange: ['', [
        Validators.required,
        this.noWhitespaceValidator,
        Validators.pattern(/^-?\d+(\.\d+)?$/) // Ensures numeric input
      ]],
      questionId: [this.questionId]
    })
  }
  saveRangeColumnItem() {
    let startRange: number = Number(this.rangeColumnItemForm.controls.startRange.value) || 0;
    let endRange: number = Number(this.rangeColumnItemForm.controls.endRange.value) || 5;
    let questionId: number = Number(this.rangeColumnItemForm.controls.questionId.value) || 0;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: {
        startRange: startRange.toString(),
        endRange: endRange.toString(),
        questionId: questionId.toString()
      }
    };


    this.http.post<any>(this.myAppUrl + '/' + this.MATRIX_ENDPOINT.SAVE_RANGE_COLUMN_DATA, '', httpOptions).subscribe(result => {
      this.columnDataNew = result;
      this.showMessage("Column Item Created / Updated Successfully");
      this.messageTimeout();
      this.questionColumnItemId = 0;
      this.selectedColumnHeaderList = [];
      this.columnItemForm.reset();
      //$('#columnItemModal').modal('hide');
    });
  }
  CloseModal() {
    this.showAddColumnModal = false;
  }
  AddColumnData(isButtonClick: boolean) {
    console.log('Opening modal...');
    this.showAddColumnModal = isButtonClick;

    this.selectedColumnHeaderList = [];
    let param = "?questionId=" + this.questionId;
    this.commonService.httpGet("", this.myAppUrl + '/' + this.MATRIX_ENDPOINT.COLUMN_DATA + param).subscribe(response => {
      this.dataTypeList = response.dataTypeList;
      this.controlTypeList = response.controlTypeList;
      this.picklistReferenceList = response.picklistReferenceList;
      this.questionColumnHeaderList = response.questionColumnHeaderList;
    }, error => console.error(error));
    this.questionColumnItemId = 0;
    this.columnItemForm = this.formBuilder.group({
      columnItemDescription: ['', [Validators.required, this.noWhitespaceValidator]],
      questionColumnHeaderId: [0],
      controlTypeId: [0],
      picklistReferenceId: [0],
      minValue: [''],
      maxValue: [''],
      dataTypeId: [0],
      isMandatory: [0],
      isEnabled: [1],
      questionId: [this.questionId],
      questionColumnItemId: [0],
      displayOrder: [1],
      width: [0],
    })
  }

  columnHeaderDefs: ColDef[] = [
    { headerName: 'QuestionId', field: 'questionId', hide: true },
    { headerName: 'QuestionColumnHeaderId', field: 'questionColumnHeaderId', hide: true },
    { headerName: 'Description', field: 'qsHeaderDescription', rowDrag: true, cellRenderer: this.editHeaderCellRenderer.bind(this), resizable: true, filter: true },
    { headerName: 'Delete', field: 'Delete', cellRenderer: this.deleteColumnHeaderRenderer.bind(this), resizable: true }
  ];
  columnItemDefs: ColDef[] = [
    { headerName: 'QuestionId', field: 'questionId', hide: true },
    { headerName: 'questionColumnItemId', field: 'questionColumnItemId', hide: true },
    { headerName: 'Description', field: 'columnItemDescription', rowDrag: true, cellRenderer: this.editColumnItemCellRenderer.bind(this), resizable: true, filter: true },
    { headerName: 'questionColumnHeaderId', field: 'questionColumnHeaderId', hide: true },
    { headerName: 'Control Type', field: 'controlTypeName', resizable: true, filter: true },
    { headerName: 'Column Header', field: 'questionColumnHeaderName', resizable: true, filter: true },
    { headerName: '', field: 'Delete', width: 45, cellRenderer: this.deleteColumnItemRenderer.bind(this), resizable: true }
  ];

  rowItemDefs: ColDef[] = [
    { headerName: 'QuestionId', field: 'questionId', hide: true },
    { headerName: 'rowItemHeaderId', field: 'rowItemHeaderId', hide: true },
    { headerName: 'Description', field: 'rowItemHeaderDescription', rowDrag: true, cellRenderer: this.editRowItemCellRenderer.bind(this), resizable: true, filter: true },
    { headerName: 'Delete', cellRenderer: this.deleteRowItemRenderer.bind(this), resizable: true }
  ];
  questionDefaultValueDefs: ColDef[] = [
    { headerName: 'QuestionId', field: 'questionId', hide: true },
    { headerName: 'RowItemId', field: 'questionRowItemId', hide: true },
    { headerName: 'ColumnItemId', field: 'questionColumnItemId', hide: true },
    { headerName: 'questionDefaultValueId', field: 'questionDefaultValueId', hide: true },
    { headerName: 'Default Value', field: 'defaultValue', rowDrag: true, cellRenderer: this.editDefaultValueCellRenderer.bind(this), resizable: true, filter: true },
    { headerName: 'Delete', cellRenderer: this.deleteDefaultValueRenderer.bind(this), resizable: true }
  ];
  editColumnItemCellRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const attr = this.renderer.createText(params.value);
    this.renderer.setAttribute(element, 'href', 'javascript:void(0);');
    this.renderer.setAttribute(element, 'title', params.value);

    this.renderer.appendChild(element, attr);
    this.renderer.listen(element, 'click', () => {
      this.showAddColumnModal = true;
      this.questionColumnItemId = params.data.questionColumnItemId;
      this.questionColumnHeaderId = params.data.questionColumnHeaderId;
      this.questionId = params.data.questionId;
      this.columnItemForm.patchValue({
        questionColumnItemId: params.data.questionColumnItemId,
        columnItemDescription: params.data.columnItemDescription,
        questionColumnHeaderId: params.data.questionColumnHeaderId,
        questionColumnHeaderName: params.data.questionColumnHeaderName,
        isMandatory: params.data.isMandatory,
        controlTypeId: params.data.controlTypeId,
        controlTypeName: params.data.controlTypeName,
        picklistReferenceId: params.data.picklistReferenceId,
        picklistReferenceName: params.data.picklistReferenceName,
        minValue: params.data.minValue,
        maxValue: params.data.maxValue,
        isEnabled: params.data.isEnabled,
        dataTypeId: params.data.dataTypeId,
        dataTypeName: params.data.dataTypeName,
        questionId: params.data.questionId,
        displayOrder: params.data.displayOrder,
        width: params.data.width,
      });
      this.questionColumnHeaderList = [];
      if (this.questionColumnHeaderId > 0) {
        let columnHeaderSelected: ColumnHeader = {
          questionColumnHeaderId: params.data.questionColumnHeaderId, questionId: this.questionId,
          qsHeaderDescription: params.data.questionColumnHeaderName, displayOrder: "1"
        };
        this.questionColumnHeaderList.push(columnHeaderSelected);
        this.selectedColumnHeaderList.push(this.questionColumnHeaderId.toString());
      }
      else {
        let param = "?questionId=" + this.questionId + "&controlTypeId=" + this.columnItemForm.controls.controlTypeId.value;
        this.commonService.httpGet("", this.myAppUrl + '/' + this.MATRIX_ENDPOINT.COLUMN_DATA + param).subscribe(response => {
          this.questionColumnHeaderList = response.questionColumnHeaderList;
          this.picklistReferenceList = response.picklistReferenceList;
        }, error => console.error(error));
      }

    });
    return element;
  }

  editRowItemCellRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const attr = this.renderer.createText(params.value);
    this.renderer.setAttribute(element, 'href', 'javascript:void(0);');
    this.renderer.setAttribute(element, 'title', params.value);
    this.renderer.appendChild(element, attr);
    this.renderer.listen(element, 'click', () => {
      this.rowItemHeaderId = params.data.rowItemHeaderId;
      this.rowItemForm.patchValue({
        rowItemHeaderDescription: params.data.rowItemHeaderDescription
      });

    });
    return element;
  }
  editDefaultValueCellRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const attr = this.renderer.createText(params.value);
    this.renderer.setAttribute(element, 'href', 'javascript:void(0);');
    this.renderer.setAttribute(element, 'title', params.value);
    this.renderer.appendChild(element, attr);
    this.renderer.listen(element, 'click', () => {
      this.questionDefaultValueId = params.data.questionDefaultValueId;
      this.questionDefaultValueForm.patchValue({
        questionDefaultValueId: params.data.questionDefaultValueId,
        defaultValue: params.data.defaultValue,
        questionId: params.data.questionId,
        questionRowItemId: params.data.questionRowItemId,
        questionColumnItemId: params.data.questionColumnItemId,
      });

    });
    return element;
  }

  editHeaderCellRenderer(params: any) {
    var element = this.renderer.createElement('a');
    var attr = this.renderer.createText(params.value);
    this.renderer.setAttribute(element, 'href', 'javascript:void(0);');
    this.renderer.setAttribute(element, 'title', params.value);
    this.renderer.appendChild(element, attr);
    this.renderer.listen(element, 'click', () => {
      this.questionColumnHeaderId = params.data.questionColumnHeaderId;
      this.columnHeaderForm.patchValue({
        qsHeaderDescription: params.data.qsHeaderDescription
      });

    });
    return element;
  }

  public deleteColumnHeaderRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);
    this.renderer.setStyle(element, 'cursor', 'pointer');
    this.renderer.listen(element, 'click', () => {
      this.questionColumnHeaderId = params.data.questionColumnHeaderId;
      this.questionId = params.data.questionId;
      this.openDeleteColumnHeaderModal();
    });
    return element;
  }

  deleteColumnHeader() {
    let param = "?questionColumnHeaderId=" + this.questionColumnHeaderId + "&questionId=" + this.questionId;
    this.commonService.httpGet('', this.myAppUrl + '/' + this.MATRIX_ENDPOINT.DELETE_COLUMN_HEADER + param).subscribe(result => {
      this.columnHeaderList = result.listOfColumnHeader;
      this.questionColumnHeaderId = 0;
      this.showMessage("Column Header Deleted Successfully");
      this.messageTimeout();
      this.questionColumnHeaderId = 0;
      // Refresh the grid
      if (this.gridApiColumnHeader) {
        this.gridApiColumnHeader.setRowData(this.columnHeaderList);
      }
    }, error => console.error(error));
  }
  public deleteColumnItemRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);
    this.renderer.setStyle(element, 'cursor', 'pointer');
    this.renderer.listen(element, 'click', () => {
      this.questionColumnItemId = params.data.questionColumnItemId;
      this.questionId = params.data.questionId;
      this.openDeleteColumnItemModal();
    });
    return element;
  }

  deleteColumnItem() {
    let param = "?questionColumnItemId=" + this.questionColumnItemId + "&questionId=" + this.questionId;
    this.commonService.httpGet('', this.myAppUrl + '/' + this.MATRIX_ENDPOINT.DELETE_COLUMN_ITEM + param).subscribe(result => {
      this.columnDataNew = result.listOfColumnItem;
      this.questionColumnHeaderId = 0;
      this.showMessage("ColumnItem Deleted Successfully");
      this.messageTimeout();
      this.questionColumnItemId = 0;
      // Refresh the grid
      if (this.gridApiColumnItem) {
        this.gridApiColumnItem.setRowData(this.columnDataNew);
      }
    }, error => console.error(error));
  }

  public deleteRowItemRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);
    this.renderer.setStyle(element, 'cursor', 'pointer');
    this.renderer.listen(element, 'click', () => {
      this.rowItemDeleteId = params.data.rowItemHeaderId;
      this.questionId = params.data.questionId;
      this.openDeleteRowItemModal();
    });
    return element;
  }

  deleteRowItem() {
    let param = "?rowItemHeaderId=" + this.rowItemDeleteId.toString() + "&questionId=" + this.questionId.toString();
    this.commonService.httpGet('', this.myAppUrl + '/' + this.MATRIX_ENDPOINT.DELETE_ROW_ITEM + param).subscribe(result => {
      this.rowItemList = result.listOfRowItem;
      this.showMessage("RowItem Deleted Successfully");
      this.messageTimeout();
      this.rowItemHeaderId = 0;
      // Refresh the grid
      if (this.gridApiRowItem) {
        this.gridApiRowItem.setRowData(this.rowItemList);
      }
    }, error => console.error(error));

  }
  public deleteDefaultValueRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);
    this.renderer.setStyle(element, 'cursor', 'pointer');
    this.renderer.listen(element, 'click', () => {
      this.questionDefaultValueId = params.data.questionDefaultValueId;
      this.questionId = params.data.questionId;
      this.openDeleteDefaultValueModal();
    });
    return element;
  }
  backUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.folderId == -1)
        this._router.navigate(['/question']);
      else
        this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
    }
    else {
      this._router.navigate(['/programoverview']);
    }
  }

  deleteDefaultValue() {
    let param = "?questionDefaultValueId=" + this.questionDefaultValueId + "&questionId=" + this.questionId;
    this.commonService.httpGet('', this.myAppUrl + '/' + this.MATRIX_ENDPOINT.DELETE_DEFAULT_VALUE + param).subscribe(result => {
      this.questionDefaultValueList = result.listOfDefaultValue;
      this.questionDefaultValueId = 0;
      this.showMessage("Column Header Deleted Successfully");
      this.messageTimeout();
      this.questionDefaultValueId = 0;
      // Refresh the grid
      if (this.gridApiDefaultValue) {
        this.gridApiDefaultValue.setRowData(this.questionDefaultValueList);
      }
    }, error => console.error(error));
  }
  public addHeader() {
    if (this.columnHeaderForm.controls.qsHeaderDescription.value.trim() == '') return;
    if (this.questionColumnHeaderId == undefined) {
      this.questionColumnHeaderId = 0;
    }
    var exists = this.columnHeaderList.find(x => x.qsHeaderDescription == this.columnHeaderForm.controls.qsHeaderDescription.value && x.questionId == this.questionId);
    if (exists == undefined) {
      this.columnHeaderForm.setValue({
        qsHeaderDescription: this.columnHeaderForm.controls.qsHeaderDescription.value.trim(),
        questionId: this.questionId,
        questionColumnHeaderId: this.questionColumnHeaderId,
      });

      let columnparam = "model=" + JSON.stringify(this.columnHeaderForm.value);
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };

      this.http.post<any>(this.myAppUrl + '/' + this.MATRIX_ENDPOINT.SAVE_COLUMN_HEADER, this.columnHeaderForm.value, httpOptions).subscribe(result => {
        this.columnHeaderList = result.listOfColumnHeader;
        this.columnHeaderForm.reset();
        this.showMessage("Column Header Created / Updated Successfully");
        this.messageTimeout();
        this.questionColumnHeaderId = 0;
      }, error => console.error(error));
    }
    else {
      this.questionColumnHeaderId = 0;
      this.columnHeaderForm.reset();
      this.showMessage("Column Header Already Exists");
      this.messageTimeout();
    }
  }
  messageTimeout() {
    window.setTimeout(() => {
      this.hideMessage();
    }, 1800);
  }
  messageColumnItemTimeout() {
    window.setTimeout(() => {
      this.hideColumnItemMessage();
    }, 1800);
  }
  showMessage(params: any) {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "block";
    }
    var message = document.getElementById('message');
    if (message) {
      message.innerText = params;
    }
  }
  showColumnItemMessage(params: any) {
    var divMessage = document.getElementById('columnItemMsgContainer');
    if (divMessage) {
      divMessage.style.display = "block";

    }
    var message = document.getElementById('exception');
    if (message) {
      message.innerText = params;

    }
  }
  hideColumnItemMessage() {
    var divMessage = document.getElementById('columnItemMsgContainer');
    if (divMessage) {
      divMessage.style.display = "none";
    }
    var message = document.getElementById('exception');
    if (message) {
      message.innerText = '';
    }
  }
  hideMessage() {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "none";
    }
    var message = document.getElementById('message');
    if (message) {
      message.innerText = '';
    }
  }
  public addQuestion() {
    this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
    this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
    if (this.questionForm.controls.qsDescription.value.trim() == '') return;
    if (this.questionId == undefined)
      this.questionId = 0;
    let userId = this.EncrDecr.get(localStorage.getItem('userId') || "");
    this.questionForm.setValue({
      createdBy: userId,
      qsDescription: this.questionForm.controls.qsDescription.value.trim(),
      questionId: this.questionId,
      modifiedBy: userId,
      folderId: this.folderId,
      isHideRowHeader: this.questionForm.controls.isHideRowHeader.value,
      isEveryRowMandatory: this.questionForm.controls.isEveryRowMandatory.value,
      questionCategoryId: this.questionForm.controls.questionCategoryId.value,
      width: this.questionForm.controls.width.value,
      shortName: this.questionForm.controls.shortName.value
    });
    let param = "model=" + JSON.stringify(this.questionForm.value);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    this.http.post<any>(this.myAppUrl + '/' + this.MATRIX_ENDPOINT.SAVE_QUESTION, this.questionForm.value, httpOptions).subscribe(result => {
      this.questionId = result;
      if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
        this.mapQuestionsToSection(this.questionId, this.redirectedSurveyId, this.redirectedSectionId)
      }
      this.showMessage("Matrix Question Created / Updated Successfully");
      this.messageTimeout();
    }, error => console.error(error));
  }
  public resetHeaderForm() {
    this.questionColumnHeaderId = 0;
    this.columnHeaderForm.reset();
  }
  public resetRowItemForm() {
    this.rowItemHeaderId = 0;
    this.rowItemForm.reset();
  }
  public resetDefaultValueForm() {
    this.questionDefaultValueId = 0;
    this.questionDefaultValueForm.reset();
  }
  public saveColumnItem() {
    if (this.questionColumnItemId == undefined)
      this.questionColumnItemId = 0;
    let minvalue: number = Number(this.columnItemForm.controls.minValue.value) || 0;
    let maxvalue: number = Number(this.columnItemForm.controls.maxValue.value) || 0;
    let controlTypeIdValue = this.columnItemForm.controls.controlTypeId.value;
    let controlType = this.controlTypeList.find(x => x.controlTypeId == controlTypeIdValue);
    if (controlType != null && controlType != undefined) {
      let pickListId = this.columnItemForm.controls.picklistReferenceId.value;
      if (controlType.controlType != '' && controlType.controlType.toUpperCase() == "PICKLIST") {
        if (pickListId == undefined || pickListId == null || pickListId == 0) {
          this.showColumnItemMessage("Please select Pick List");
          this.messageColumnItemTimeout();
          //this.hideColumnItemForm = false;
          //$('#btnSave').removeAttr('data-dismiss');
          return;
        }
      }
    }
    if (minvalue > 0 && maxvalue > 0) {
      if (minvalue > maxvalue) {
        this.showColumnItemMessage("Min.Value should be lesser than Max.Value");
        this.messageColumnItemTimeout();
        //this.hideColumnItemForm = false;
        //$('#btnSave').removeAttr('data-dismiss');
        return;
      }
      else {
        this.addColumnItem();
      }
    }
    else {
      this.addColumnItem();
    }
  }
  public addColumnItem() {
    if (this.columnItemForm.controls.columnItemDescription.value.trim() == '') return;
    let concatenated = '';
    for (var i = 0; i < this.selectedColumnHeaderList.length; i++) {
      concatenated = concatenated + this.selectedColumnHeaderList[i] + ",";
    }
    //let param = "model=" + JSON.stringify(this.columnItemForm.value) + "&questionColumnItemId=" + this.questionColumnItemId
    //  + "&questionColumnHeaderIdList=" + concatenated;
    if (concatenated == '' && this.questionColumnHeaderList.length > 0) {
      concatenated = this.questionColumnHeaderList[0].questionColumnHeaderId.toString();
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: {
        questionColumnItemId: this.questionColumnItemId.toString(),
        questionColumnHeaderIdList: concatenated
      }
    };

    // Prepare the model with correct types
    const formValue = this.columnItemForm.value;
    const payload = {
      ...formValue,
      isMandatory: formValue.isMandatory === 1 || formValue.isMandatory === true,
      isEnabled: formValue.isEnabled === 1 || formValue.isEnabled === true,
      minValue: formValue.minValue !== '' ? Number(formValue.minValue) : null,
      maxValue: formValue.maxValue !== '' ? Number(formValue.maxValue) : null,
      questionId: this.questionId
    };
    this.http.post<any>(
      `${this.myAppUrl}/${this.MATRIX_ENDPOINT.SAVE_COLUMN_DATA}`,
      payload, // <--- send the model directly, not { model: payload }
      httpOptions
    ).subscribe(result => {
      this.columnDataNew = result.listOfColumnItem;
      this.showMessage("Column Item Created / Updated Successfully");
      this.messageTimeout();
      this.questionColumnItemId = 0;
      this.selectedColumnHeaderList = [];
      this.columnItemForm.reset();
      this.showAddColumnModal = false;
      //$('#columnItemModal').modal('hide');
    });
  }
  public addRowItem() {
    if (this.rowItemForm.controls.rowItemHeaderDescription.value.trim() == '') return;
    if (this.rowItemHeaderId == undefined)
      this.rowItemHeaderId = 0;
    this.rowItemForm.setValue({
      rowItemHeaderDescription: this.rowItemForm.controls.rowItemHeaderDescription.value.trim(),
      questionId: this.questionId,
      rowItemHeaderId: this.rowItemHeaderId,
    });
    let rowparam = "model=" + JSON.stringify(this.rowItemForm.value);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    this.http.post<any>(this.myAppUrl + '/' + this.MATRIX_ENDPOINT.SAVE_ROW_ITEM, this.rowItemForm.value, httpOptions).subscribe(result => {
      this.rowItemList = result.listOfRowItem;
      this.rowItemForm.reset();
      this.showMessage("Row Item Created / Updated Successfully");
      this.messageTimeout();
      this.rowItemHeaderId = 0;
    }, error => console.error(error));
  }
  public addQuestionDefaultValue() {
    if (this.questionDefaultValueForm.controls.defaultValue.value.trim() == '') return;
    if (this.questionDefaultValueId == undefined)
      this.questionDefaultValueId = 0;
    this.questionDefaultValueForm.setValue({
      questionDefaultValueId: this.questionDefaultValueId,
      defaultValue: this.questionDefaultValueForm.controls.defaultValue.value.trim(),
      questionId: this.questionId,
      questionRowItemId: this.questionDefaultValueForm.controls.questionRowItemId.value,
      questionColumnItemId: this.questionDefaultValueForm.controls.questionColumnItemId.value,
    });
    let rowparam = "model=" + JSON.stringify(this.questionDefaultValueForm.value);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    this.http.post<any>(this.myAppUrl + '/' + this.MATRIX_ENDPOINT.SAVE_DEFAULT_VALUE, this.questionDefaultValueForm.value, httpOptions).subscribe(result => {
      this.questionDefaultValueList = result.listOfDefaultValue;
      this.questionDefaultValueForm.reset();
      this.showMessage("DefaultValue Created / Updated Successfully");
      this.messageTimeout();
      this.questionDefaultValueId = 0;
    }, error => console.error(error));
  }
  updateSelectedColumnHeaders(event: any) {
    if (event.target.checked) {
      if (this.selectedColumnHeaderList.indexOf(event.target.name) < 0) {
        this.selectedColumnHeaderList.push(event.target.name);

      }
    } else {
      if (this.selectedColumnHeaderList.indexOf(event.target.name) > -1) {
        this.selectedColumnHeaderList.splice(this.selectedColumnHeaderList.indexOf(event.target.name), 1);
      }
    }

  }
  openCategoryModal() {
    if (this.categoryModal) {
      this.modalService.open(this.categoryModal);
    }
  }
  openDeleteRowItemModal() {
    if (this.deleteRowItemModalRef) {
      this.modalService.open(this.deleteRowItemModalRef);
    }
  }
  openDeleteColumnHeaderModal() {
    if (this.deleteColumnHeaderModalRef) {
      this.modalService.open(this.deleteColumnHeaderModalRef);
    }
  }
  openDeleteColumnItemModal() {
    if (this.deleteColumnItemModalRef) {
      this.modalService.open(this.deleteColumnItemModalRef);
    }
  }
  openDeleteDefaultValueModal() {
    if (this.deleteDefaultValueModalRef) {
      this.modalService.open(this.deleteDefaultValueModalRef);
    }
  }
  openRangeColumnItemModal() {
    this.AddRangeColumnData();
    if (this.rangeColumnItemModalRef) {
      this.modalService.open(this.rangeColumnItemModalRef);
    }
  }
  mapQuestionsToSection(questionid: any, surveyId: any, currentSectionId: any) {
    var concatenated = questionid.toString();

    let questionIdList = "questionIdList=" + concatenated + "&surveyId=" + surveyId + "&sectionId=" + currentSectionId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(questionIdList, this.myAppUrl + '/' + this.SURVEY_ENDPOINT.MAP_QUESTION_TO_SECTION, httpOptions).subscribe(result => {
      window.setTimeout(() => {
        this.successOrFailureMessage = '';
      }, 1200);
    }, error => console.error(error));

  }
  backToSectionUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
        this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
      }
    }
    else {
      this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
    }
  }
}

interface Question {
  questionId: number;
  qsDescription: string;
  questionTypeId: number;
  createdBy: number;
  modifiedBy: number;
  folderId: number;
  isHideRowHeader: boolean;
  isEveryRowMandatory: boolean;
}
interface QuestionDefaultValue {
  questionDefaultValueId: number;
  questionRowItemId: number;
  defaultValue: string;
  questionId: number;
  questionColumnItemId: number;
}
interface ColumnItem {
  questionColumnItemId: string;
  columnItemDescription: string;
  questionId: number;
  questionColumnHeaderId: number;
  displayOrder: number;
  isMandatory: boolean;
  controlTypeId: number;
  picklistReferenceId: number;
  minValue: string;
  maxValue: string;
  isEnabled: boolean;
  dataTypeId: number;
  questionColumnHeaderName: string;
  controlTypeName: string;
  picklistReferenceName: string;
  dataTypeName: string;
  width: number;
}

interface ColumnHeader {
  questionId: number;
  questionColumnHeaderId: number;
  qsHeaderDescription: string;
  displayOrder: string;
}

interface DataType {
  dataTypeId: number;
  typeName: string;
}

interface ControlType {
  controlTypeId: number;
  controlType: string;
}

interface PickListreference {
  picklistReferenceId: number;
  picklistReferenceDescription: string;
}

interface RowItem {
  questionId: number;
  rowItemHeaderId: number;
  rowItemHeaderDescription: string;
  displayOrder: string;
}

interface questionCategory {
  questionCategoryId: number;
  questionCategoryName: string;
}
